import React, { useContext, useRef } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import PixelTabIcons from 'app/common/PixelTabIcons'
import { OrdersContext } from 'contexts/OrdersContext'
import _ from 'lodash'
import moment from 'moment'
import {
  DcBreadcrumbs,
  DcDiv,
  DcFlexBox,
  DcInput,
  DcTabs,
  Section,
  SectionContent,
  PixelFactoryContext,
  PixelPageContainer,
  SectionActions,
  DcOverlaySlider,
  colors,
  DcButton,
} from 'pixel-base'
import queryString from 'query-string'
import { AjaxResponse } from 'rxjs/ajax'
import styled from 'styled-components'

import { get } from 'utils/api-routes.util'
import FilterLinesIcon from 'utils/icons/filter-lines-icon'
import OrderDetailsPanel from './components/OrderDetailsPanel'
import OrdersActions from './components/OrdersActions'
import OrdersBulkEdit from './components/OrdersBulkEdit'
import OrdersSubHeader from './components/OrdersSubHeader'
import OrdersTable from './components/OrdersTable'
import OrderStatusComponent from './components/OrderStatus'
import UpdateOrderStatus from './components/OrderStatusUpdate'
import UploadExcelOrder from './UploadExcelOrder'
import {
  IOrder,
  IFilters,
  ILinkedStore,
  IAllowedCourier,
  ISplitOrder,
  IStatusGroup,
  IPixelFactory,
} from '../../../decl.d'

const breadcrumbs = [
  {
    name: 'Orders',
    active: true,
  },
]

const formatOptions = (data) => {
  const options = _.groupBy(data, (item) => item.name)
  const dropdownOptions = {}
  Object.keys(options).map((key) => {
    const op = options[key][0]
    dropdownOptions[key] = op?.children?.map((item) => {
      item.value = item.id
      item.label = item.title
      return item
    })
  })
  return dropdownOptions
}

const Orders = () => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = React.useState(false)
  const [showOrderDetailModal, SetShowOrderDetailModal] = React.useState(false)
  const p = queryString.parse(window.location.search) as {
    store_id?: string
    page?: string
    id?: string
    tag?: string
    start_date?: string
    end_date?: string
    courier_id?: string
    page_size?: string
    status_classification_id?: string
    order_id?: string
  }
  const context = useContext<IPixelFactory>(PixelFactoryContext)

  const { showFailure, showPageLoader, hidePageLoader } = context

  const { state, setStateItem } = React.useContext(OrdersContext)
  const [dateFilter, setDateFilter] = React.useState<{
    start_date: string | null
    end_date: string | null
  }>({
    start_date: null,
    end_date: null,
  })

  const [filters, setFilters] = React.useState<IFilters>({
    store_id: null,
    page: null,
    page_size: null,
    start_date: null,
    end_date: null,
    courier_id: null,
    tag: null,
    id: null,
    status_classification_id: null,
    searchBy: null,
  })
  const defaultFilters = {
    page: 0,
    page_size: 50,
  }
  const [appliedFiltersIds, setAppliedFiltersIds] = React.useState<IFilters>({
    store_id: null,
    page: null,
    id: null,
    tag: null,
    start_date: null,
    end_date: null,
    courier_id: null,
    page_size: null,
    q: null,
    status_classification_id: null,
  })
  const [appliedFilters, setAppliedFilters] = React.useState<
    Array<{ id: string; name: string; value: string | null }>
  >([])
  const [storesList, setStoresList] = React.useState<ILinkedStore[]>([])
  const [courierList, setCourierList] = React.useState<IAllowedCourier[]>([])
  const [selectedStore, setSelectedStore] = React.useState<ILinkedStore | null>(
    null,
  )

  const [orders, setOrders] = React.useState<IOrder[]>([])

  const [isClosePopover, setIsClosePopover] = React.useState<boolean>(false)
  const [showUpdateStatusModal, setShowUpdateStatusModal] =
    React.useState<boolean>(false)
  const [reload, setReload] = React.useState<any>(false)
  const [splitOrder, setSplitOrder] = React.useState<ISplitOrder>({
    isSplit: false,
    splitId: null,
  })

  const [selectedOrders, setSelectedOrders] = React.useState<IOrder[]>([])
  const [groupedStatus, setGroupedStatus] = React.useState<IStatusGroup[]>([])
  const [toggledClearRows, setToggleClearRows] = React.useState(false)
  const [showFilterModal, setShowFilterModal] = React.useState(false)
  const [isVisible, setIsVisible] = React.useState(false)

  const handleClearRows = () => {
    // Clear both sources of truth. Use functional toggle so clears still work when
    // called from readData's stable []-deps callback (stale toggledClearRows closure).
    setSelectedOrders([])
    setToggleClearRows((prev) => !prev)
  }

  React.useEffect(() => {
    setStoresList(
      state?.linkedStores?.map((store) => ({
        store_id: store.store_id,
        store_name: store.store_name,
        store_type: store.store_type,
        store_status: store.store_status || 'active',
        created_at: store.created_at || new Date().toISOString(),
      })) || [],
    )
    setCourierList(
      state?.couriers?.map(
        (courier) =>
          ({
            courier_id: courier.courier_id,
            courier_name: courier.courier_name,
          } as IAllowedCourier),
      ) || [],
    )

    const selected_store = state?.linkedStores?.find((store) => {
      return store.store_id.toString() === filters.store_id?.toString()
    })
    setSelectedStore(
      selected_store
        ? {
            store_id: selected_store.store_id,
            store_name: selected_store.store_name,
            store_type: selected_store.store_type,
            store_status: selected_store.store_status || 'active',
            created_at: selected_store.created_at || new Date().toISOString(),
          }
        : null,
    )
  }, [state])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [newOrder, setNewOrder] = React.useState(false)
  const [orderId, setOrderId] = React.useState<string | null>(null)
  const [totalRows, setTotalRows] = React.useState(0)
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)
  const onlyAppliedFilters = (filters) => {
    const appliedFilters = {}
    Object.keys(filters).map((key) => {
      const value = filters[key]
      if (key === 'start_date' || key === 'end_date') {
        const date = moment(value)
        if (date.isValid()) {
          appliedFilters[key] = date.format('YYYY-MM-DD')
        }
      } else if (value !== null && value !== undefined && value !== '') {
        // Keep values like 0 (e.g., page = 0)
        appliedFilters[key] = value
      }
    })
    return appliedFilters
  }

  React.useEffect(() => {
    navigate({
      pathname: '/orders',
      search: queryString.stringify(onlyAppliedFilters(filters)),
    })
    // Let the guarded effect trigger readData; avoid firing with stale page
    handleClearRows()
  }, [filters])
  React.useEffect(() => {
    refresh()
    handleClearRows()
  }, [reload])

  React.useEffect(() => {
    if (groupedStatus.length === 0) setGroupedStatus(state.groupedStatuses)
  }, [state.groupedStatuses])

  const headerRef = useRef<HTMLDivElement>(null)
  const currentRequestId = useRef(0)
  const initialLoadRef = useRef(true)
  const filtersRef = useRef(filters)
  const prevFiltersRef = useRef(filters)

  const isReadingRef = useRef(false)
  // Unified filter formatting function that both APIs can use
  const formatFiltersForAPI = React.useCallback((filtersToFormat: IFilters) => {
    const formatFilters = {
      store_id: filtersToFormat.store_id
        ? Number(filtersToFormat.store_id)
        : null,
      courier_id: filtersToFormat.courier_id
        ? Number(filtersToFormat.courier_id)
        : null,
      tag: filtersToFormat.tag,
      start_date: filtersToFormat.start_date
        ? moment(filtersToFormat.start_date).format('YYYY-MM-DD')
        : null,
      end_date: filtersToFormat.end_date
        ? moment(filtersToFormat.end_date).format('YYYY-MM-DD')
        : null,
      page: filtersToFormat.page,
      id: filtersToFormat.id ? filtersToFormat.id : null,
      q: filtersToFormat.q,
      page_size: filtersToFormat.page_size,
      status_classification_id: filtersToFormat.status_classification_id
        ? Number(filtersToFormat.status_classification_id)
        : null,
      searchBy: filtersToFormat.searchBy,
    }

    // Only include filters that have actual values
    const newItems = {}
    Object.entries(formatFilters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        newItems[key] = value
      }
    })

    return newItems
  }, [])

  filtersRef.current = filters
  const readData = React.useCallback(() => {
    if (isReadingRef.current) return

    // Guard: if any non-pagination filter changed, ensure page is 0 before issuing request
    const prev = prevFiltersRef.current
    const current = filtersRef.current
    const nonPaginationKeys = [
      'store_id',
      'start_date',
      'end_date',
      'courier_id',
      'tag',
      'id',
      'status_classification_id',
      'q',
      'searchBy',
    ] as const
    const nonPaginationChanged = nonPaginationKeys.some(
      (k) => (prev as any)?.[k] !== (current as any)?.[k],
    )
    if (nonPaginationChanged && current.page !== 0) {
      setFilters({ ...current, page: 0 })
      prevFiltersRef.current = { ...current, page: 0 }
      return
    }

    isReadingRef.current = true
    setTableLoading(true)
    showPageLoader()

    currentRequestId.current += 1
    const requestId = currentRequestId.current
    const newItems = formatFiltersForAPI(filtersRef.current)

    const subscription = get('/orders', newItems).subscribe({
      next: (res: AjaxResponse<any>) => {
        if (requestId === currentRequestId.current) {
          const response = res.response as {
            data: IOrder[]
            _meta: { total: number }
          }
          setOrders(response?.data || [])
          if (response?._meta?.total) {
            setTotalRows(response?._meta?.total)
          } else {
            setTotalRows(0)
          }
          handleClearRows()
          isReadingRef.current = false
          setTableLoading(false)
          hidePageLoader()
          // update prev filters after successful read
          prevFiltersRef.current = filtersRef.current
        }
      },
      error: () => {
        if (requestId === currentRequestId.current) {
          isReadingRef.current = false
          setTableLoading(false)
          hidePageLoader()
          prevFiltersRef.current = filtersRef.current
        }
      },
      complete: () => {
        if (requestId === currentRequestId.current) {
          isReadingRef.current = false
          setTableLoading(false)
          hidePageLoader()
          prevFiltersRef.current = filtersRef.current
        }
      },
    })

    return () => {
      subscription.unsubscribe()
      if (requestId === currentRequestId.current) {
        isReadingRef.current = false
        setTableLoading(false)
        hidePageLoader()
        prevFiltersRef.current = filtersRef.current
      }
    }
  }, [])

  // Single useEffect to handle all readData triggers
  React.useEffect(() => {
    // If any non-pagination filter changed, force page reset to 0
    const prev = prevFiltersRef.current
    const nonPaginationKeys = [
      'store_id',
      'start_date',
      'end_date',
      'courier_id',
      'tag',
      'id',
      'status_classification_id',
      'q',
      'searchBy',
    ] as const
    const nonPaginationChanged = nonPaginationKeys.some(
      (k) => (prev as any)?.[k] !== (filters as any)?.[k],
    )
    if (nonPaginationChanged && filters.page !== 0) {
      setFilters({ ...filters, page: 0 })
      prevFiltersRef.current = { ...filters, page: 0 }
      return
    }

    if (initialLoadRef.current) {
      readData()
      initialLoadRef.current = false
    } else if (Object.keys(filters).length > 0) {
      readData()
    }

    // update prev after acting on current change
    prevFiltersRef.current = filters
  }, [filters, readData])

  // Remove other readData triggers
  const refresh = React.useCallback(() => {
    setTableLoading(true)
    readData()
  }, [readData])

  React.useEffect(() => {
    setReload(false)
    setTableLoading(true)
    readData()
  }, [reload])

  // Remove the reload effect
  React.useEffect(() => {
    if (groupedStatus.length === 0) {
      setGroupedStatus(state.groupedStatuses)
    }
  }, [state.groupedStatuses])

  React.useEffect(() => {
    let storeName: string | null = null
    const storeId = 'store_id' in appliedFiltersIds
    if (storeId) {
      if (storesList?.length > 0) {
        storeName =
          storesList?.find(
            (key) =>
              key.store_id.toString() ===
              appliedFiltersIds.store_id?.toString(),
          )?.store_name ?? null
      }
    }

    let dates = ''
    const startDate =
      appliedFiltersIds.start_date &&
      moment(appliedFiltersIds.start_date).isValid()
        ? moment(appliedFiltersIds.start_date).format('ll')
        : null
    const endDate =
      appliedFiltersIds.end_date && moment(appliedFiltersIds.end_date).isValid()
        ? moment(appliedFiltersIds.end_date).format('ll')
        : null

    if (startDate && endDate) {
      dates = `${startDate} > ${endDate}`
    }

    const allFilters = [
      {
        id: 'start_date',
        name: 'Order Date',
        value: dates || null,
      },
      {
        id: 'store_id',
        name: 'Store',
        value: storeName,
      },
      {
        id: 'tag',
        name: 'Tag',
        value: appliedFiltersIds.tag ? appliedFiltersIds.tag : null,
      },
      {
        id: 'id',
        name: 'Sub Status',
        value: filters.id ? filters.id : null,
      },
      {
        id: 'status_classification_id',
        name: 'Status',
        value: filters.status_classification_id || null,
      },
    ]
    setAppliedFilters(
      allFilters.filter((filter) => filter.value !== null) as Array<{
        id: string
        name: string
        value: string | null
      }>,
    )
  }, [appliedFiltersIds, storesList, courierList])

  const handlePageChange = (page) => {
    if (filters.page === page - 1) return
    setFilters({
      ...filters,
      page: page - 1,
    })
  }

  const handleChange = ({ selectedRows }) => {
    if (selectedOrders !== selectedRows) {
      setSelectedOrders(selectedRows)
    }
  }

  const applyFilter = (key, value, enable = true) => {
    if (filters[key] === value && enable) return
    if (enable) {
      setFilters({
        ...filters,
        [key]: value,
        page: 0,
      })
    } else {
      setFilters({
        ...filters,
        [key]: null,
        page: 0,
      })
    }
  }
  const [searchValue, setSearchValue] = React.useState('')

  React.useEffect(() => {
    readData()
  }, [reload])

  const debounceFn = React.useCallback(
    _.debounce((value) => {
      setResetPaginationToggle(value.length > 0)
      const val = value
      setFilters({
        ...filters,
        q: val,
        page: 0,
      })
    }, 1000),
    [filters],
  )

  const handleUpdate = (
    data: any,
    dispatch: any,
    action: string,
    dispatch_id: string | null,
  ) => {
    if (action === 'consignments') {
      setOrders(
        orders.map((item) => {
          if (data[item.number]) {
            if (data[item.number].tracking.error) {
              if (dispatch) {
                showFailure(data[item.number].tracking.error)
              } else {
                showFailure(
                  dispatch_id === null
                    ? `${data[item.number].tracking.error}`
                    : `Dispatch is created but ${
                        data[item.number].tracking.error
                      }`,
                )
              }
              item = {
                ...item,
                courier: data[item.number].tracking?.courier || null,
              }
            } else {
              item = {
                ...item,
                courier: data[item.number].tracking || null,
              }
            }
          }
          return item
        }),
      )

      // Clear parent selection and DataTable checkboxes.
      // selectableRowSelected: null was a no-op (DataTable ignores falsy values).
      handleClearRows()

      return
    }
    if (action === 'prepareDispatch') {
      refresh()
      return
    }

    if (action === 'cancel-consignment') {
      const order_ids = Object.keys(_.groupBy(data.orders, 'order_id'))

      setOrders(
        Object.assign(
          [],
          [
            ...orders.map((item) => {
              if (order_ids.includes(`${item.number}`)) {
                item.courier = {}
              }
              return { ...item }
            }),
          ],
        ),
      )

      return
    }

    refresh()
  }

  type ExportableOrder = IOrder & {
    meta?: { order_source?: string }
    is_split_child?: boolean
    split_source_order_id?: string
    store_order_id?: string
    source_order_id?: string
    store_id?: string | number | null
    status?: string
    total?: number | string | null
    date_created?: string | Date | null
    courier?: {
      tracking_id?: string
      tracking?: string
      courier_name?: string
    } | null
    shipping?: {
      first_name?: string
      last_name?: string
      city?: string
      phone?: string
    } | null
  }

  const getOrderReference = (order: ExportableOrder) => {
    if (order?.meta?.order_source === 'ems') {
      if (order?.is_split_child && order?.split_source_order_id) {
        return order.split_source_order_id
      }
      return order?.store_order_id || order?.source_order_id || '--'
    }
    return order?.source_order_id || order?.store_order_id || '--'
  }

  const getTrackingValue = (order: ExportableOrder) => {
    const trackingId = order?.courier?.tracking_id
    const orderRef = `${order?.store_id}-${order?.source_order_id}`
    if (trackingId && orderRef === trackingId) {
      return 'awaiting'
    }
    return trackingId || order?.courier?.tracking || '--'
  }

  const escapeCsvValue = (value: string | number | null | undefined) => {
    if (value === null || value === undefined) {
      return ''
    }
    const normalized =
      typeof value === 'string' ? value : (value as number | boolean).toString()
    const sanitized = normalized.replace(/"/g, '""')
    return /[",\n]/.test(sanitized) ? `"${sanitized}"` : sanitized
  }

  const buildOrdersCsv = (rows: ExportableOrder[]) => {
    const header = [
      'Order #',
      'Status',
      'Date',
      'Customer',
      'City',
      'Phone',
      'Amount',
      'Tracking',
      'Courier',
    ]

    const dataRows = rows.map((order) => {
      const customerName = [
        order?.shipping?.first_name || '',
        order?.shipping?.last_name || '',
      ]
        .join(' ')
        .trim()

      return [
        getOrderReference(order),
        order?.status || '--',
        order?.date_created && moment(order.date_created).isValid()
          ? moment(order.date_created).format('YYYY-MM-DD HH:mm')
          : '--',
        customerName || '--',
        order?.shipping?.city || '--',
        order?.shipping?.phone || '--',
        order?.total !== null && order?.total !== undefined
          ? order.total.toString()
          : '--',
        getTrackingValue(order),
        order?.courier?.courier_name || '--',
      ]
    })

    return [header, ...dataRows]
  }

  const downloadOrdersCsv = (rows: string[][]) => {
    const csvContent = rows
      .map((row) => row.map(escapeCsvValue).join(','))
      .join('\n')
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `orders-${moment().format('YYYY-MM-DD-HHmmss')}.csv`,
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const exportReport = () => {
    if (!orders || orders.length === 0) {
      showFailure('No orders available to export')
      return
    }

    const csvRows = buildOrdersCsv(orders as ExportableOrder[])
    downloadOrdersCsv(csvRows)
  }

  const subHeaderComponentMemo = React.useMemo(
    () => (
      <OrdersSubHeader
        totalRows={totalRows}
        selectedOrders={selectedOrders}
        refresh={refresh}
        handleClearRows={handleClearRows}
        handleUpdate={handleUpdate}
        selectedStore={selectedStore}
        tableLoading={tableLoading}
        filters={filters}
        setFilters={setFilters}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        debounceFn={debounceFn}
        appliedFilters={appliedFilters}
        appliedFiltersIds={appliedFiltersIds}
        setAppliedFiltersIds={setAppliedFiltersIds}
        setStateItem={setStateItem}
      />
    ),
    [
      filters,
      setFilters,
      searchValue,
      selectedOrders,
      resetPaginationToggle,
      totalRows,
      appliedFilters,
      storesList,
      tableLoading,
    ],
  )
  const onRowClicked = (row) => {
    setOrderId(row.number)
    setNewOrder(false)
    SetShowOrderDetailModal(true)
  }

  React.useEffect(() => {
    if (p.order_id) {
      setOrderId(p.order_id)
      SetShowOrderDetailModal(true)
      // Update URL to remove the order parameter
      navigate('/orders', { replace: true })
    }
  }, [p.order_id])

  const handlePerRowsChange = async (newPerPage) => {
    setFilters({
      ...filters,
      page_size: newPerPage,
      page: 0,
    })
  }

  return (
    <PixelPageContainer
      style={{ padding: '0px', maxHeight: '100vh', height: '100vh' }}
    >
      <Section style={{ padding: '0px' }}>
        <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
          <DcFlexBox
            padding="8px 20px"
            style={{
              justifyContent: 'space-between',
              borderBottom: `1px solid ${colors.grayBorderLight}`,
            }}
            alignItems="center"
          >
            <DcFlexBox alignItems="center" width="auto">
              <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
              <SectionActions />
            </DcFlexBox>
            <DcDiv>
              <ProfileSection />
            </DcDiv>
          </DcFlexBox>
        </SectionContent>
      </Section>
      <DcDiv
        width="100%"
        backgroundColor={colors.blueLightBg}
        overflow="auto"
        padding="0"
        height="calc(100vh - 61px)"
      >
        <BrowserView>
          <Section
            style={{
              padding: '0',
              border: 'none',
              borderRadius: '0px',
              position: 'relative',
              zIndex: 30,
            }}
            ref={headerRef}
          >
            <SectionContent
              style={{
                border: 'none',
                borderRadius: '0px',
                padding: '0 10px 0px 10px',
              }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="flex-end"
                width="100%"
                gap="8px"
                style={{
                  minWidth: 0,
                  maxWidth: '100%',
                }}
              >
                <StoreTabsRegion>
                  <DcTabs
                    variant="default"
                    size="md"
                    tabs={[
                      {
                        store_name: 'All Stores',
                        store_id: null,
                        store_type: null,
                        store_status: 'active',
                        created_at: new Date().toISOString(),
                      },
                      ...storesList,
                    ].map((store, index) => ({
                      label: store.store_name || '',
                      value: store.store_id ? `${store.store_id}` : null,
                      icon: (
                        <PixelTabIcons
                          store_type={store.store_type || null}
                          isActive={
                            filters.store_id?.toString() ===
                            store.store_id?.toString()
                          }
                        />
                      ),
                    }))}
                    activeTab={
                      filters.store_id
                        ? `${filters.store_id}`
                        : filters.store_id
                    }
                    handleChange={(value: string) => {
                      const storeId = value
                      setFilters({
                        ...filters,
                        store_id:
                          storeId === null ? null : parseInt(storeId, 10),
                        page: 0,
                      })
                    }}
                  />
                </StoreTabsRegion>
                <ActionsRegion>
                  <OrdersActions
                    dateFilter={dateFilter}
                    setDateFilter={setDateFilter}
                    filters={filters}
                    setFilters={setFilters}
                    defaultFilters={defaultFilters}
                    setNewOrder={setNewOrder}
                    setOrderId={setOrderId}
                    SetShowOrderDetailModal={SetShowOrderDetailModal}
                    setShowModal={setShowModal}
                    setShowUpdateStatusModal={setShowUpdateStatusModal}
                    exportReport={exportReport}
                    isClosePopover={isClosePopover}
                    setIsClosePopover={setIsClosePopover}
                    setAppliedFiltersIds={setAppliedFiltersIds}
                  />
                </ActionsRegion>
              </DcFlexBox>
            </SectionContent>
          </Section>

          <OrderStatusComponent
            filters={filters}
            setFilters={setFilters}
            filterApplied={applyFilter}
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            handleClearRows={handleClearRows}
            formatFiltersForAPI={formatFiltersForAPI}
          />
        </BrowserView>
        <Section style={{ padding: '20px' }}>
          <SectionContent
            style={{ padding: '10px', boxShadow: 'none !important' }}
          >
            <MobileView>
              <MobileRow>
                <DcFlexBox position="relative" alignItems="center" gap="5px">
                  <DcInput
                    showsearchicon={1}
                    style={{ backgroundColor: colors.grayLighter }}
                    maxLength={20}
                    placeholder="Search"
                    name="search"
                    onChange={(ev) => {
                      setSearchValue(ev.target.value)
                      debounceFn(ev.target.value)
                    }}
                    value={searchValue}
                  />
                  <DcDiv position="absolute" right="0px" top="7px">
                    <DcButton
                      variant="link"
                      display="inline-flex"
                      alignItems="center"
                      onClick={() => setShowFilterModal(true)}
                    >
                      <FilterLinesIcon size={16} />
                    </DcButton>
                  </DcDiv>
                </DcFlexBox>
              </MobileRow>

              <MobileRow>
                {totalRows > 0 && selectedOrders.length > 0 && (
                  <OrdersBulkEdit
                    refresh={refresh}
                    handleClearRows={handleClearRows}
                    selectedOrders={selectedOrders}
                    handleUpdate={handleUpdate}
                    selectedStore={selectedStore}
                  />
                )}
              </MobileRow>
            </MobileView>
            <OrdersTable
              orders={orders}
              tableLoading={tableLoading}
              totalRows={totalRows}
              filters={filters}
              handlePerRowsChange={handlePerRowsChange}
              handlePageChange={handlePageChange}
              onRowClicked={onRowClicked}
              handleChange={handleChange}
              toggledClearRows={toggledClearRows}
              selectedOrders={selectedOrders}
              resetPaginationToggle={resetPaginationToggle}
              subHeaderComponent={subHeaderComponentMemo}
              isVisible={isVisible}
            />
          </SectionContent>
        </Section>
      </DcDiv>
      {showModal && (
        <UploadExcelOrder
          show={showModal}
          handleClose={() => {
            setShowModal(false)
          }}
        />
      )}

      <DcOverlaySlider
        isOpen={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        title="Filters"
        width="20% !important"
        padding="0px"
        customWith={'40%'}
      >
        <OrdersActions
          dateFilter={dateFilter}
          setDateFilter={setDateFilter}
          filters={filters}
          setFilters={setFilters}
          defaultFilters={defaultFilters}
          setNewOrder={setNewOrder}
          setOrderId={setOrderId}
          SetShowOrderDetailModal={SetShowOrderDetailModal}
          setShowModal={setShowModal}
          setShowUpdateStatusModal={setShowUpdateStatusModal}
          exportReport={exportReport}
          isClosePopover={isClosePopover}
          setIsClosePopover={setIsClosePopover}
          setAppliedFiltersIds={setAppliedFiltersIds}
        />
      </DcOverlaySlider>
      <DcOverlaySlider
        title="Update Status"
        width="40%"
        onClose={() => setShowUpdateStatusModal(false)}
        isOpen={!!showUpdateStatusModal}
      >
        <UpdateOrderStatus
          setReload={setReload}
          handelClose={() => setShowUpdateStatusModal(false)}
          columns={1}
        />
      </DcOverlaySlider>

      <OrderDetailsPanel
        show={showOrderDetailModal}
        orderId={orderId}
        setOrderId={setOrderId}
        newOrder={newOrder}
        setNewOrder={setNewOrder}
        splitOrder={splitOrder}
        setSplitOrder={setSplitOrder}
        SetShowOrderDetailModal={SetShowOrderDetailModal}
        setReload={setReload}
        filters={filters}
      />
    </PixelPageContainer>
  )
}
const MobileRow = styled.div<{ inline?: boolean }>`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  align-content: center;
  flex-wrap: ${({ inline }) => (inline ? 'nowrap' : 'wrap')};
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;
`

/*
 * Store tabs take remaining row width and scroll horizontally.
 * ActionsRegion keeps Date/actions at intrinsic width so they never collide.
 */
const StoreTabsRegion = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: 80%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  z-index: 0;

  scrollbar-width: thin;
  scrollbar-color: ${colors.grayBorderMedium} transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: ${colors.grayBorderMedium};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.grayMedium};
  }

  & > div {
    width: max-content;
    min-width: 100%;
  }
`

const ActionsRegion = styled.div`
  flex: 0 0 auto;
  min-width: max-content;
  white-space: nowrap;
  position: relative;
  z-index: 2;
`

export default Orders
